export const environment = {
  version: '3.3.1.54',
  version_web: '3.3.1.54',
  production: true,
  api: '/api'
};

